<script>
  import { ShieldCheck, ShieldAlert, FileCheck, ShieldOff } from 'lucide-svelte';
  import { _ } from '../lib/i18n.js';
  import { SIGNATURE_STATES, normalizeSignatureState, signatureStateLabelKey } from './signatureState.js';

  /**
   * The document's state: `'bound'`, `'unbound'`, `'manual'`, or `null` when no
   * document of that kind is stored. Proposal rows publish it directly
   * (`customerSignatureState` / `finalSignatureState`); callers holding a full
   * record pass `signatureStateOf(record)`.
   */
  export let state = null;
  /** Icon-and-label only, sized for a table cell. */
  export let compact = false;

  // Normalised, so a state written by a newer backend renders as unverified
  // rather than falling through to "no document" — or, worse, to green.
  $: shown = normalizeSignatureState(state);
  $: labelKey = signatureStateLabelKey(state);

  // Colour follows the claim, not the happy path: only `bound` is green.
  $: badgeClass = shown === SIGNATURE_STATES.BOUND
    ? 'bg-green-100 dark:bg-green-900/50 text-green-800 dark:text-green-300 border-green-200 dark:border-green-800'
    : shown === SIGNATURE_STATES.MANUAL
      ? 'bg-amber-100 dark:bg-amber-900/50 text-amber-800 dark:text-amber-300 border-amber-200 dark:border-amber-800'
      : shown === SIGNATURE_STATES.UNBOUND
        ? 'bg-orange-100 dark:bg-orange-900/50 text-orange-800 dark:text-orange-300 border-orange-200 dark:border-orange-800'
        : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-gray-600';
</script>

<span
  class="inline-flex items-center rounded border font-medium {compact ? 'px-1.5 py-0 text-[11px]' : 'px-2 py-0.5 text-xs'} {badgeClass}"
  title={$_(labelKey)}
>
  {#if shown === SIGNATURE_STATES.BOUND}
    <ShieldCheck class="h-3 w-3 mr-1 flex-shrink-0" />
  {:else if shown === SIGNATURE_STATES.MANUAL}
    <FileCheck class="h-3 w-3 mr-1 flex-shrink-0" />
  {:else if shown === SIGNATURE_STATES.UNBOUND}
    <ShieldAlert class="h-3 w-3 mr-1 flex-shrink-0" />
  {:else}
    <ShieldOff class="h-3 w-3 mr-1 flex-shrink-0" />
  {/if}
  {$_(labelKey)}
</span>
